import constants from './constants';
import glossary from './glossary';

const {
  TOURNAMENT_MEMBER_STATUS,
  TOURNAMENT_MEMBER_ACTIONS,
  TOURNAMENT_MEMBER_PRIZE_PLACE,
} = constants;

const {
  TOURNAMENT_MEMBER_PRIZE_PLACE_DATA,
} = glossary;

const getActionsByStatus = (status) => {
  const {
    transfer,
    finish,
    remove,
    resume,
    levelTransfer,
  } = TOURNAMENT_MEMBER_ACTIONS;
  switch (status) {
    case TOURNAMENT_MEMBER_STATUS.waited: return [transfer, finish, remove];
    case TOURNAMENT_MEMBER_STATUS.ended: return [levelTransfer, resume];
    default: return [];
  }
};

const getPrizePlaceByAwards = (prize_place, awards_settings = {}) => {
  const { prize_places_count, prize_winners_places } = awards_settings || {};
  if (
    !prize_places_count
    || !prize_place
    || (Number(prize_place) > Number(prize_places_count))
  ) return TOURNAMENT_MEMBER_PRIZE_PLACE.member;
  if (
    prize_winners_places
    && (Number(prize_place) >= Number(prize_winners_places))
  ) return TOURNAMENT_MEMBER_PRIZE_PLACE.awarded;
  return TOURNAMENT_MEMBER_PRIZE_PLACE.winner;
};

const getPrizePlacesAttrsByAwards = (awards_settings = {}) => {
  const { prize_places_count, prize_winners_places } = awards_settings || {};
  const memberItem = { id: null, name: TOURNAMENT_MEMBER_PRIZE_PLACE_DATA[TOURNAMENT_MEMBER_PRIZE_PLACE.member]?.name };
  if (!prize_places_count) {
    return {
      disabled: true,
      items: [memberItem],
    };
  }
  const winners = Math.max((prize_winners_places ?? 0) - 1, 0) || prize_places_count;
  const awarded = prize_winners_places ? prize_places_count - Math.max((prize_winners_places ?? 0) - 1, 0) : 0;

  return {
    items: [
      ...Array.from({ length: winners }, (_, i) => i + 1).map((i) => ({
        id: i,
        name: [
          `${i} место`,
          `(${TOURNAMENT_MEMBER_PRIZE_PLACE_DATA[TOURNAMENT_MEMBER_PRIZE_PLACE.winner]?.name})`,
        ].join(' '),
      })),
      ...Array.from({ length: awarded }, (_, i) => winners + i + 1).map((i) => ({
        id: i,
        name: [
          `${i} место`,
          `(${TOURNAMENT_MEMBER_PRIZE_PLACE_DATA[TOURNAMENT_MEMBER_PRIZE_PLACE.awarded]?.name})`,
        ].join(' '),
      })),
      memberItem,
    ],
  };
};

export default {
  getActionsByStatus,
  getPrizePlaceByAwards,
  getPrizePlacesAttrsByAwards,
};
